import { useTheme } from "next-themes";

/** Fargesett for Recharts som følger lyst/mørkt tema. */
export function useChartTheme() {
  const { resolvedTheme } = useTheme();
  const dark = resolvedTheme === "dark";
  return {
    dark,
    grid: dark ? "rgba(148,163,184,0.18)" : "#E6EDF3",
    tick: dark ? "#A8B3C2" : "#5B6776",
    cursor: dark ? "rgba(148,163,184,0.10)" : "#F4F6F8",
    primary: dark ? "#2EA3AD" : "#0E7490",
    primarySoft: dark ? "rgba(46,163,173,0.45)" : "#8FC7D1",
    paid: dark ? "rgba(110,231,160,0.55)" : "#8FC7D1",
    unpaid: dark ? "#2EA3AD" : "#0E7490",
    avtalegiro: dark ? "#8B8FF0" : "#3730A3",
    line: dark ? "#2EA3AD" : "#0E7490",
  };
}
